module.exports = __webpack_public_path__ + "10b616f83881c4149661e9e9fad02fad.svg";